import React from 'react';
import { connect } from 'react-redux';
import ConfirmationDialog from '../../components/ConfirmationDialog';
import { deleteProgramFile, setDeleteProgramFileDialog } from '../../lib/store/actions/programs';
import {
  selectIsDeleteProgramFileDialogOpen,
  selectIsDeletingProgramFile,
} from '../../lib/store/selectors/programs';

function DeleteProgramFileDialog({
  isOpen,
  isDeleting,
  fileId,
  onSetDeleteProgramFileDialog,
  onDeleteProgramFile,
  fileName,
  onDeleteCB,
}) {
  const closeDialog = () => {
    onSetDeleteProgramFileDialog(false);
  };

  const deleteCurrentPlaylistSong = () => {
    onDeleteProgramFile({ fileId }, () => {
      onSetDeleteProgramFileDialog(false);
      onDeleteCB();
    });
  };

  return (
    <ConfirmationDialog
      isOpen={isOpen}
      onCancel={closeDialog}
      onConfirm={deleteCurrentPlaylistSong}
      isInProgress={isDeleting}
      inProgressMessage="Deleting, please wait ..."
      confirmationBody={
        <>
          Please confirm you'd like to delete "{fileName}"?
          <br />
          <br />
          <strong>Note:</strong> This action cannot be undone.
        </>
      }
      confirmationBtnText="Yes, delete it!"
    />
  );
}

const mapStateToProps = state => {
  return {
    isOpen: selectIsDeleteProgramFileDialogOpen(state),
    isDeleting: selectIsDeletingProgramFile(state),
  };
};

export default connect(
  mapStateToProps,
  {
    onSetDeleteProgramFileDialog: setDeleteProgramFileDialog,
    onDeleteProgramFile: deleteProgramFile,
  }
)(DeleteProgramFileDialog);
